import { FirestoreService } from "../firebase/firestoreService";
import { MenuCart, TemporaryMenuCartStoreType } from "../../models/fullMenuCart";
import { DIFFERENT_RESTAURANT_ERROR } from "../../models/errors";
import { getCached } from "../firebase/firestoreCache";

const TEMPORARY_MENU_COLLECTION_NAME = "temporaryMenuCart";

export const FullMenuCheckoutService = {
    async removeTemporaryMenuCart(profileId: string) {
        await FirestoreService.deleteDocument(TEMPORARY_MENU_COLLECTION_NAME, profileId);
    },
    async getTemporaryMenuCart(profileId: string) {
        const data = await FirestoreService.getDocument(TEMPORARY_MENU_COLLECTION_NAME, profileId);
        return data as TemporaryMenuCartStoreType | null;
    },
    async getTemporaryMenuCartCached(profileId: string, ttlMs = 5_000, cacheBust = false) {
        const key = `customerTemporaryCart:${profileId}`;
        return getCached(key, () => FullMenuCheckoutService.getTemporaryMenuCart(profileId), ttlMs, cacheBust);
    },
    async updateTemporaryMenuCart(cart: MenuCart, profileId: string): Promise<TemporaryMenuCartStoreType | null> {
        let cartToStore = await FullMenuCheckoutService.getTemporaryMenuCartCached(profileId)
        if (cartToStore) {
            cartToStore.updatedAt = new Date()
            if (cartToStore.cart.restaurantId != cart.restaurantId) {
                throw DIFFERENT_RESTAURANT_ERROR()
            }
            cartToStore.cart = cart
            await FirestoreService.updateDocument(TEMPORARY_MENU_COLLECTION_NAME, profileId, cartToStore);
        } else {
            cartToStore = {
                cart,
                profileId,
                updatedAt: new Date(),
                createdAt: new Date()
            }
            await FirestoreService.setDocument(TEMPORARY_MENU_COLLECTION_NAME, profileId, cartToStore);
        }
        return cartToStore;
    }
}